var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoneyOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_156_5793",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_156_5793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8501 16.85C28.3834 15.7166 27.7168 14.8333 26.8501 14.2C25.9834 13.5666 24.9501 13.25 23.7501 13.25C22.7168 13.25 21.8001 13.425 21.0001 13.775C20.2001 14.125 19.5168 14.6333 18.9501 15.3L16.8501 13.2C17.5501 12.4 18.3584 11.7666 19.2751 11.3C20.1918 10.8333 21.1668 10.5333 22.2001 10.4V5.99998H25.2001V10.35C26.6001 10.5166 27.8751 11.025 29.0251 11.875C30.1751 12.725 31.0834 13.95 31.7501 15.55L28.8501 16.85ZM40.3001 45.2L30.7001 35.6C29.9668 36.3 29.1251 36.8166 28.1751 37.15C27.2251 37.4833 26.2334 37.6833 25.2001 37.75V42H22.2001V37.7C20.3001 37.4333 18.7168 36.675 17.4501 35.425C16.1834 34.175 15.2834 32.65 14.7501 30.85L17.7501 29.8C18.2168 31.5 18.9751 32.7666 20.0251 33.6C21.0751 34.4333 22.4001 34.85 24.0001 34.85C24.8668 34.85 25.7084 34.7416 26.5251 34.525C27.3418 34.3083 28.0001 33.9333 28.5001 33.4L2.8501 7.74998L5.0001 5.59998L42.4501 43.05L40.3001 45.2Z",
    fill: "#0BAB47"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyOff);
export default __webpack_public_path__ + "static/media/money_off.dc91abb777c834d54ea5b5cca1d3927a.svg";
export { ForwardRef as ReactComponent };